export const personalInfo = {
  name: 'Ajit Choudhary',
  title: 'Full-Stack Developer',
  location: 'Ratnagiri, India',
  tagline: 'Building products that ship.',
  description: 'I build end-to-end web and mobile applications — from React frontends to Python/Node backends and Flutter apps. 1+ year professional experience, 20+ freelance projects delivered to real clients.',
  email: 'ajitcc55@gmail.com',
  github: 'https://github.com/Ajit-2111',
  linkedin: 'https://linkedin.com/in/ajitchoudhary',
  availability: 'Open to remote opportunities',
  education: 'BE in IT · CGPA 8.58 · FAMT 2023'
};

export const stats = [
  {
    number: '20+',
    label: 'Freelance projects delivered to paying clients'
  },
  {
    number: '2k+',
    label: 'Products tracked monthly on my supply chain app'
  },
  {
    number: '100%',
    label: 'Frontend ownership — sole contributor to enterprise React app serving 1,000+ users'
  },
  {
    number: '8+',
    label: 'Technologies across the full stack — React, .NET, Python, Flutter, Node.js, Docker & more'
  }
];

export const techStack = {
  frontend: ['React.js', 'Next.js', 'TypeScript', 'JavaScript', 'HTML5 / CSS3', 'Figma → Code', 'Responsive UI'],
  backend: ['Python', 'Flask', 'FastAPI', 'Django', '.NET Core Web API', 'Node.js', 'Express.js', 'REST APIs'],
  mobile: ['Flutter', 'Dart', 'AWS (EC2, S3)', 'Azure', 'Docker', 'Git / GitHub'],
  database: ['MySQL', 'MongoDB', 'PostgreSQL', 'Scikit-learn', 'OpenAI API', 'RAG / Vector Search']
};

export const experience = [
  {
    company: 'Gadre Infotech',
    role: 'Junior Software Developer',
    period: 'Sep 2024 – Present',
    location: 'Ratnagiri, India',
    description: 'Sole frontend contributor on two production applications — an enterprise supply chain platform and a medical web app for doctors.',
    highlights: [
      'Built and own 100% of the React.js frontend for an enterprise supply chain app tracking 2,000+ products monthly — from architecture to deployment.',
      'Also contributed 25–35% of backend .NET Core API development — authentication flows, data endpoints, and error handling.',
      'Shipped the full frontend for a medical platform used by ~1,000 doctors; translated Figma designs to pixel-perfect responsive UI with zero revision cycles.',
      'Worked in agile sprints of 2–5 developers — sprint planning, code reviews, bug triage, consistent on-time delivery.'
    ],
    technologies: ['React.js', '.NET Core', 'REST APIs', 'JavaScript', 'Figma', 'Git']
  },
  {
    company: 'Self-employed',
    role: 'Freelance Full-Stack Developer',
    period: 'Jul 2022 – Sep 2024',
    location: 'Remote · International & Domestic',
    description: '20+ paid client projects delivered end-to-end — web platforms, mobile apps, internal tools, and AI-enabled products.',
    highlights: [
      'Managed the complete project lifecycle independently: requirements → development → deployment → client handoff.',
      'Built Python/Flask and FastAPI backends for SaaS MVPs; cross-platform Flutter mobile apps deployed to real users.',
      'Maintained async client communication across time zones; iterated on feedback rapidly and met all deadlines solo.'
    ],
    technologies: ['Python', 'Flask', 'FastAPI', 'Flutter', 'React.js', 'Node.js', 'MySQL', 'MongoDB']
  }
];

export const projects = [
  {
    title: 'AI Interview Prep Platform',
    description: 'AI-powered interview simulator that generates role-specific questions, records responses, and delivers structured AI evaluation feedback in real time. Full-stack: React frontend + Python backend + AI evaluation pipeline.',
    technologies: ['React', 'Python', 'AI/LLM', 'Flask'],
    github: 'https://github.com/Ajit-2111/ai-interview-prep',
    category: 'AI'
  },
  {
    title: 'Chat with Documents (RAG)',
    description: 'Document Q&A system that lets users query uploaded PDFs using natural language. Implemented retrieval-augmented generation (RAG) with vector-based search for accurate, context-aware answers.',
    technologies: ['Python', 'Flask', 'RAG', 'Vector Search'],
    github: 'https://github.com/Ajit-2111/document-converse',
    category: 'AI'
  },
  {
    title: 'Hostel Management System',
    description: 'Full-stack web application handling student records, room allocation, fee tracking, and admin workflows — built with role-based access control and clean MVC architecture.',
    technologies: ['PHP', 'MySQL'],
    github: 'https://github.com/Ajit-2111/hostel-management-system',
    category: 'Web'
  },
  {
    title: 'Library Management System',
    description: 'Desktop app managing book inventory, issue/return workflows, due calculations, and user records — focused on clean architecture, data handling, and ease of use.',
    technologies: ['TKinter', 'Python', 'MySQL'],
    github: 'https://github.com/Ajit-2111/Library-Management-System',
    category: 'Desktop'
  },
  {
    title: 'Sign Language Detection',
    description: 'Real-time computer vision tool that detects and interprets sign language gestures — built to help bridge communication gaps for the hearing-impaired community.',
    technologies: ['Python', 'OpenCV', 'Scikit-learn'],
    github: 'https://github.com/Ajit-2111/sign-language-detection',
    category: 'ML'
  },
  {
    title: 'Emotion Recognition',
    description: 'Real-time emotion detection from images and video streams using computer vision and machine learning — identifies facial expressions across multiple emotional states.',
    technologies: ['Python', 'OpenCV', 'ML'],
    github: 'https://github.com/Ajit-2111/emotion-detection',
    category: 'ML'
  }
];

export const certifications = [
  {
    issuer: 'Microsoft',
    title: 'Azure AI Fundamentals'
  },
  {
    issuer: 'Microsoft',
    title: 'Introduction to Programming Using JavaScript'
  },
  {
    issuer: 'freeCodeCamp',
    title: 'Responsive Web Design'
  },
  {
    issuer: 'Palo Alto Networks',
    title: 'Cybersecurity Foundation'
  },
  {
    issuer: 'Oracle University',
    title: 'Data Science Professional'
  },
  {
    issuer: 'IBM',
    title: 'Introduction to Web Development with HTML, CSS, JavaScript'
  }
];
